import React, { FunctionComponent } from 'react';
import classnames from 'classnames';
import styled from 'styled-components';
import StylesType from '@/types/StylesType';
import './style';

export interface DeviceInfoProps extends StylesType{
    /** 异常设备数量 */
    abnormal?: number;
    /** 将要过期设备数量 */
    willExpire?: number;
    /** 选中设备数量 */
    selected?: number;
    /** 开通ip代理设备数量 */
    openedIpAgent?: number;
    /** 开通ip代理设备数量 */
    openedOneClickNewMachine?: number;
}

export declare interface PropsMap {
    [key: string]: number;
}

export interface SpanProps {
    readonly color: string;
};

export interface DivProps {
    readonly margin: string;
    readonly padding: string;
    readonly border: boolean;
}

const DeviceInfoData = [
    {
        name: '异常',
        type: 'abnormal',
        color: 'red',
        left: 20,
        right: 0
    },
    {
        name: '即将到期',
        type: 'willExpire',
        color: 'red',
        left: 40,
        right: 32.5
    },
    {
        name: '已选',
        type: 'selected',
        color: '#000',
        left: 20,
        right: 0
    },
    {
        name: '订购IP',
        type: 'openedIpAgent',
        color: '#000',
        left: 40,
        right: 0
    },
    {
        name: '一键新机',
        type: 'openedOneClickNewMachine',
        color: '#000',
        left: 40,
        right: 0
    }
]

/* 展示当前分组下设备信息 */
export const DeviceInfo: FunctionComponent<DeviceInfoProps&PropsMap> = props => {
  
    const { prefixCls = 'gc-device-info' } = props;
  
    const DeviceInfoList = DeviceInfoData.map(item =>
        <Div border={item.type === 'willExpire'} padding={`${item.right}px`} margin={`0 0 0 ${item.left}px`} key={item.type}>
            <span>{item.name}：</span>
            <Span color={item.color}>{props[item.type]}</Span>
            <span>台</span>
        </Div>
    )
  
    return (
        <div className={classnames(prefixCls)} >
            {DeviceInfoList}
        </div>
    )
  
}

DeviceInfo.defaultProps = {
    abnormal: 0,
    willExpire: 0,
    selected: 0,
    openedIpAgent: 0,
    openedOneClickNewMachine: 0,
}

const Span = styled.span<SpanProps>`
  color: ${props => props.color};
  margin-right: 4px
`

const Div = styled.div<DivProps>`
  margin: ${props => props.margin};
  padding: ${props => props.padding}
  border-right: ${props => props.border ? '1px solid #E1E3E6' : 0};
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export default DeviceInfo;
